// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"65b5511b","453":"dda23872","455":"589565cf","977":"b61e4276"}[chunkId] + ".chunk.js";
};